/* SPEC-129 E2 · cs-medicion v4.1 — exposición por bloque, CTA, apertura de formulario y (v4, anexo F) carruseles,
   tiras, videos e higiene de tráfico en las páginas de venta.
   PROPUESTA de Coordinación CRO para el implementador (único que edita el tema). No se sube sin su revisión
   y sin «publica» del operador. Contrato: colmena-cro-eventos/1 (anexo C de SPEC-129).
   Cada página tiene su estructura; el script reconoce tres modos (anexo C §2b):
     cs         → secciones cs_* del sistema del implementador (id estable: cs_hero, cs_tabs…)
     gem_imagen → páginas GemPages hechas de imágenes [data-label="Image"]; id por el archivo (…SECCION_7 → img_s7)
     tramos     → cualquier otra (GemPages v7, Instant, plantilla del tema): 10 tramos iguales del contenido
                  principal (t10 = 0–10 %, …, t100 = 90–100 %). Mide profundidad, no contenido.
   Publica con Shopify.analytics.publish('colmena_cro', …); lo recoge el píxel personalizado «colmena-cro».
   Sin datos personales: no lee formularios, teclado, coordenadas de clic ni parámetros de URL salvo utm_* y view.
   v4 (anexo F): observa desde fuera, sin tocar cs-landing.js ni el script de cs_videos, los carruseles
   [data-cs-carousel], las tiras [data-cs-strip] y [data-cs-compare-scroll], la pista de videos
   (.cs-vids__track), los videos [data-cs-vid] y los Swiper (.swiper). Del gesto solo guarda la vía (deslizar,
   punto, miniatura, flecha o auto), nunca coordenadas. Del referente solo el dominio; del user agent solo si es
   el navegador interno de Facebook, Instagram o TikTok. */
(function () {
  'use strict';
  if (window.__csMedicion) return; window.__csMedicion = true;
  var A = window.Shopify && window.Shopify.analytics;
  if (!A || typeof A.publish !== 'function' || !('IntersectionObserver' in window)) return;

  var ESQUEMA = 1, UMBRAL_MS = 1000, ALTO_MIN = 40, TRAMOS = 10;
  var uuid = function () {
    return (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
      : 'x' + Date.now().toString(16) + Math.random().toString(16).slice(2);
  };
  var q = new URLSearchParams(location.search);
  var utm = {};
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
    var v = q.get(k); if (v) utm[k.slice(4)] = v.slice(0, 120);
  });
  var pagina = {
    ruta: location.pathname,
    plantilla: (window._template && window._template.suffix) || null,
    view: q.get('view')
  };

  var carga, vistas, timers, maxOrden, abierto, t0Carga, med;
  function nuevaCarga() {
    carga = uuid(); vistas = {}; timers = {}; maxOrden = 0; abierto = false; vigilando = false; t0Carga = Date.now();
    med = { cambios: 0, videoEv: 0, porCarr: {}, porVideo: {}, tiras: {} };   // topes de v4, por carga
  }

  function enviar(tipo, extra) {
    var e = {
      v: ESQUEMA, tipo: tipo, evento_id: uuid(), carga_id: carga, ts: Date.now(),
      pagina: pagina, utm: utm,
      pantalla: { ancho: window.innerWidth, alto: window.innerHeight }
    };
    for (var k in extra) e[k] = extra[k];
    try { A.publish('colmena_cro', e); } catch (err) { /* nunca romper la página */ }
  }

  // ---------- Descubrimiento de bloques según el tipo de página ----------
  var raiz = document.querySelector('main') || document.getElementById('MainContent') || document.body;
  var archivo = function (img) {
    var s = img && (img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '');
    return s ? s.split('?')[0].split('/').pop().replace(/\.(avif|webp|jpe?g|png|gif)$/i, '').replace(/_\d+x\d+$/, '').slice(0, 60) : null;
  };
  var rectDe = function (el) { return function () { return el.getBoundingClientRect(); }; };

  function descubrir() {
    // La barra de anuncios y la barra fija se ven siempre: no son posiciones de contenido.
    var cs = Array.prototype.slice.call(document.querySelectorAll('[id^="shopify-section-"][id*="__cs_"]'))
      .filter(function (el) { return !/__cs_(sticky|announcement)$/.test(el.id); });
    if (cs.length) return { modo: 'cs', bloques: cs.map(function (el, i) {
      return { el: el, rect: rectDe(el), id: el.id.split('__').pop(), etiqueta: null, orden: i + 1 };
    }) };

    var imgs = Array.prototype.slice.call(raiz.querySelectorAll('[data-label="Image"]'))
      .filter(function (el) { return el.querySelector('img'); });
    if (imgs.length >= 3) return { modo: 'gem_imagen', bloques: imgs.map(function (el, i) {
      var f = archivo(el.querySelector('img')), m = f && f.match(/SECCION[_-]?(\d+)/i);
      return { el: el, rect: rectDe(el), id: m ? 'img_s' + m[1] : 'img_' + (i + 1), etiqueta: f, orden: i + 1 };
    }) };

    // Tramos: franjas virtuales del contenido principal; se recalculan con su alto real en cada evaluación.
    var tramos = [];
    for (var k = 0; k < TRAMOS; k++) (function (k) {
      tramos.push({ el: null, id: 't' + ((k + 1) * 100 / TRAMOS), etiqueta: (k * 100 / TRAMOS) + '–' + ((k + 1) * 100 / TRAMOS) + ' %', orden: k + 1,
        rect: function () {
          var r = raiz.getBoundingClientRect(), h = r.height / TRAMOS;
          return { top: r.top + k * h, bottom: r.top + (k + 1) * h, height: h };
        } });
    })(k);
    return { modo: 'tramos', bloques: tramos };
  }

  // ---------- Exposición (misma regla para los tres modos) ----------
  // Ocupa ≥50 % de la pantalla, o se ve ≥50 % del bloque si es más bajo que media pantalla; ≥1 s seguido con la
  // pestaña visible; alto ≥40 px (colapsado no cuenta). Se evalúa con la geometría real.
  var bloques = [], modo = 'sin_bloques';
  function expuesta(b) {
    var r = b.rect(), alto = window.innerHeight || 1;
    if (r.height < ALTO_MIN) return false;
    var vis = Math.max(0, Math.min(r.bottom, alto) - Math.max(r.top, 0));
    return vis >= Math.min(0.5 * alto, 0.5 * r.height);
  }
  function evaluar(b) {
    if (vistas[b.id]) return;
    var ok = document.visibilityState === 'visible' && expuesta(b);
    if (ok && !timers[b.id]) {
      timers[b.id] = setTimeout(function () {
        delete timers[b.id];
        if (vistas[b.id] || document.visibilityState !== 'visible' || !expuesta(b)) return;
        vistas[b.id] = Date.now();                                          // v4: momento de la vista
        if (b.orden > maxOrden) maxOrden = b.orden;
        enviar('seccion_vista', { modo: modo, seccion: { id: b.id, orden: b.orden, etiqueta: b.etiqueta } });
      }, UMBRAL_MS);
    } else if (!ok && timers[b.id]) { clearTimeout(timers[b.id]); delete timers[b.id]; }
  }
  function evaluarTodas() { bloques.forEach(evaluar); }
  var pendiente = false;
  function alDesplazar() {
    if (pendiente) return; pendiente = true;
    (window.requestAnimationFrame || setTimeout)(function () { pendiente = false; evaluarTodas(); });
  }

  // ---------- CTA y formularios ----------
  var SEL_CTA = '[data-cs-cta], ._rsi-buy-now-button, button[name="add"], a[href*="/checkout"], a[href*="/cart/add"]';
  // Botones que solo bajan a la caja de ofertas (snippet cs-cta y CTA final). No abren formulario ni disparan
  // InitiateCheckout: se cuentan como cta_click con modo «oferta» y no se vigila formulario.
  var SEL_OFERTA = '[data-cs-scroll-buy], a[href="#cs-oferta"]';
  function bloqueDe(el) {
    for (var i = 0; i < bloques.length; i++) if (bloques[i].el && bloques[i].el.contains(el)) return bloques[i];
    var r = el.getBoundingClientRect(), y = r.top + r.height / 2;           // botón fuera del bloque: por posición
    for (var j = 0; j < bloques.length; j++) {
      var rb = bloques[j].rect(); if (y >= rb.top && y <= rb.bottom) return bloques[j];
    }
    return null;
  }
  document.addEventListener('click', function (ev) {
    // Solo clics de una persona: cs-landing.js reenvía el clic al botón oculto de Releasit por código
    // (isTrusted = false), y contarlo duplicaría cta_click y formulario_abierto (prueba real del 2026-10-11).
    if (!ev.isTrusted) return;
    var b = ev.target && ev.target.closest && ev.target.closest(SEL_CTA);
    if (!b) {
      var o = ev.target && ev.target.closest && ev.target.closest(SEL_OFERTA);
      if (o) { var bo = bloqueDe(o); enviar('cta_click', { modo: modo, cta: { modo: 'oferta', seccion: bo ? bo.id : null } }); }
      return;
    }
    var m = b.getAttribute('data-cs-cta') || (b.closest('._rsi-buy-now-button') ? 'releasit' : 'carrito');
    var bl = bloqueDe(b);
    enviar('cta_click', { modo: modo, cta: { modo: m, seccion: bl ? bl.id : null } });
    vigilarFormulario(m);
  }, true);

  // Selectores verificados el 2026-10-10 (anexo C §4); el implementador los confirma.
  var DETECTORES = {
    releasit: function () {
      var m = document.querySelector('#_rsi-cod-form-modal');
      return !!(m && m.offsetHeight > 0 && getComputedStyle(m).visibility !== 'hidden');
    },
    cod: function () {
      var h = document.getElementById('cod-form-host'), sr = h && h.shadowRoot;
      var d = sr && sr.querySelector('.cf-overlay.open [aria-modal="true"], .cf-overlay.open [role="dialog"]');
      return !!(d && d.getBoundingClientRect().height > 0);
    }
  };
  var vigilando = false;
  function vigilarFormulario(m) {
    if (abierto || vigilando) return;
    vigilando = true;
    var t0 = Date.now(), poll = setInterval(function () {
      var f = null;
      for (var k in DETECTORES) { if (DETECTORES[k]()) { f = k; break; } }
      if (f) { abierto = true; vigilando = false; clearInterval(poll); enviar('formulario_abierto', { formulario: f, cta_modo: m, ms_desde_cta: Date.now() - t0 }); }
      else if (Date.now() - t0 > 8000) { vigilando = false; clearInterval(poll); enviar('formulario_no_visto', { cta_modo: m }); }
    }, 150);
  }

  // ---------- v4 · Tráfico (anexo F): separar lo que no es una visita humana visible ----------
  // visible_al_cargar = la pestaña estaba a la vista y no era una precarga cuando arrancó el script.
  function traficoDe(extra) {
    var ua = navigator.userAgent || '', ref = null;
    try { ref = document.referrer ? new URL(document.referrer).hostname.slice(0, 80) : null; } catch (err) { ref = null; }
    extra.visible_al_cargar = document.visibilityState === 'visible' && !document.prerendering;
    extra.ref_dominio = ref;
    extra.navegador_app = /FBAN|FBAV|FB_IAB|FBIOS/.test(ua) ? 'facebook' : /Instagram/.test(ua) ? 'instagram'
      : /musical_ly|TikTok|BytedanceWebview/i.test(ua) ? 'tiktok' : 'otro';
    return extra;
  }

  // ---------- v4 · Carruseles, tiras y videos (anexo F) ----------
  // Observador pasivo: no llama a cs-landing.js ni al script de cs_videos; mira cambios de clase y de scroll.
  // Topes por carga: 20 cambios manuales por carrusel y 40 en total; de los automáticos solo el primero por
  // carrusel; una tira emite solo cuando sube su máximo (≤10); 18 estados de video en total.
  var TOPE_CARR = 20, TOPE_CAMBIOS = 40, TOPE_VIDEO = 18, GESTO_MS = 700;
  var gestos = typeof WeakMap === 'function' ? new WeakMap() : null;   // raíz → { via, t, activo }
  var raicesCarr = [];
  function raizDe(el) {
    var m = null;
    for (var i = 0; i < raicesCarr.length; i++) {
      var r = raicesCarr[i];
      if (r.el.contains(el) && (!m || m.el.contains(r.el))) m = r;      // la más interna
    }
    return m;
  }
  function gesto(r) { var g = gestos.get(r.el); if (!g) { g = { via: null, t: 0, activo: false }; gestos.set(r.el, g); } return g; }
  function viaDe(r) {
    var g = gestos && gestos.get(r.el);
    return g && g.via && (g.activo || Date.now() - g.t <= GESTO_MS) ? g.via : 'auto';
  }
  // Solo gestos de una persona (isTrusted). Se registran en captura, antes de que cs-landing.js mueva el slide.
  var VIAS_CLIC = [
    ['[data-cs-dot], .swiper-pagination-bullet, .cs-vids__dots i', 'punto'],
    ['[data-cs-thumb]', 'miniatura'],
    ['[data-cs-prev], [data-cs-next], [data-cs-strip-prev], [data-cs-strip-next], .swiper-button-prev, .swiper-button-next', 'flecha']
  ];
  function alGesto(ev) {
    if (!ev.isTrusted || !gestos) return;
    var r = raizDe(ev.target); if (!r) return;
    var g = gesto(r), via = 'deslizar';
    if (ev.type === 'click') {
      for (var i = 0; i < VIAS_CLIC.length; i++) if (ev.target.closest(VIAS_CLIC[i][0])) { via = VIAS_CLIC[i][1]; break; }
      if (via === 'deslizar') return;          // un toque suelto en la imagen no es un cambio
    }
    g.via = via; g.t = Date.now();
    if (ev.type === 'pointerdown' || ev.type === 'touchstart') g.activo = true;
    if (ev.type === 'pointerup' || ev.type === 'pointercancel' || ev.type === 'touchend') g.activo = false;
  }
  ['pointerdown', 'pointerup', 'pointercancel', 'touchstart', 'touchend', 'click'].forEach(function (t) {
    document.addEventListener(t, alGesto, { capture: true, passive: true });
  });

  function cambio(r, desde, hasta, total, archivoSlide) {
    if (!desde || !hasta || desde === hasta) return;
    var via = viaDe(r), st = med.porCarr[r.id] || (med.porCarr[r.id] = { manual: 0, auto: false });
    if (via === 'auto') { if (st.auto) return; st.auto = true; }
    else { if (st.manual >= TOPE_CARR || med.cambios >= TOPE_CAMBIOS) return; st.manual++; med.cambios++; }
    var vt = r.bloque && vistas[r.bloque.id];
    enviar('carrusel_cambio', { modo: modo, carrusel: { id: r.id, tipo: r.tipo, total: total }, desde: desde, hasta: hasta,
      via: via, slide_archivo: archivoSlide || null, ms_desde_carga: Date.now() - t0Carga,
      ms_desde_vista: typeof vt === 'number' ? Date.now() - vt : null });
  }

  // Galería cs ([data-cs-slide] con is-active) y Swiper (.swiper-slide-active): por cambio de clase.
  function observarClase(r, selSlide, claseActiva, selDuplicado) {
    function slides() {
      return Array.prototype.filter.call(r.el.querySelectorAll(selSlide), function (s) { return !selDuplicado || !s.matches(selDuplicado); });
    }
    function activo(ss) {
      for (var i = 0; i < ss.length; i++) if (ss[i].classList.contains(claseActiva)) {
        var k = parseInt(ss[i].getAttribute('data-swiper-slide-index'), 10);
        return isNaN(k) ? i + 1 : k + 1;
      }
      var dup = selDuplicado && r.el.querySelector(selSlide + '.' + claseActiva);   // Swiper en bucle: activo duplicado
      if (dup) { var kd = parseInt(dup.getAttribute('data-swiper-slide-index'), 10); if (!isNaN(kd)) return kd + 1; }
      return null;
    }
    var actual = activo(slides());
    new MutationObserver(function () {
      var ss = slides(), k = activo(ss);
      if (!k || k === actual) return;
      var d = actual; actual = k;
      cambio(r, d, k, ss.length, ss[k - 1] ? archivo(ss[k - 1].querySelector('img')) : null);
    }).observe(r.el, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  // Desplazamiento horizontal nativo. Un scroll que llega mientras dura el gesto lo prolonga (inercia).
  function alScrollH(r, sc, fn) {
    var t = null;
    sc.addEventListener('scroll', function () {
      var g = gestos.get(r.el);
      if (g && g.via && (g.activo || Date.now() - g.t <= GESTO_MS)) g.t = Date.now();
      clearTimeout(t); t = setTimeout(fn, 150);
    }, { passive: true });
  }
  function observarPista(r, sc) {           // pista de videos: posición = tarjeta más cercana al borde izquierdo
    function pos() {
      var cs = sc.children, best = 1, dmin = Infinity;
      for (var i = 0; i < cs.length; i++) { var d = Math.abs(cs[i].offsetLeft - sc.offsetLeft - sc.scrollLeft); if (d < dmin) { dmin = d; best = i + 1; } }
      return best;
    }
    var actual = pos();
    alScrollH(r, sc, function () { var k = pos(); if (k !== actual) { var d = actual; actual = k; cambio(r, d, k, sc.children.length, null); } });
  }
  function observarTira(r, sc) {           // tira o comparativa: décimo máximo desplazado
    alScrollH(r, sc, function () {
      var rango = sc.scrollWidth - sc.clientWidth; if (rango <= 8) return;
      var f = Math.min(10, Math.floor(10 * sc.scrollLeft / rango + 0.05));
      var st = med.tiras[r.id] || 0; if (f <= st) return;
      med.tiras[r.id] = f;
      enviar('carrusel_desplazado', { modo: modo, carrusel: { id: r.id, tipo: 'tira' }, fraccion_max: f, manual: viaDe(r) !== 'auto' });
    });
  }

  function observarVideos() {
    document.querySelectorAll('[data-cs-vid] video').forEach(function (v) {
      if (v.__csMedVid) return; v.__csMedVid = true;
      var b = bloqueDe(v); if (!b) return;
      var hermanos = b.el ? b.el.querySelectorAll('[data-cs-vid] video') : [v];
      var n = Array.prototype.indexOf.call(hermanos, v) + 1 || 1, clave = b.id + ':' + n;
      function marca(e) {
        var st = med.porVideo[clave] || (med.porVideo[clave] = {});
        if (st[e] || med.videoEv >= TOPE_VIDEO) return;
        st[e] = true; med.videoEv++;
        enviar('video_estado', { modo: modo, video: { seccion: b.id, n: n, total: hermanos.length }, estado: e });
      }
      v.addEventListener('playing', function () { marca(v.muted ? 'inicio_auto' : 'inicio'); });
      v.addEventListener('volumechange', function () { if (!v.muted && v.volume > 0) marca('sonido'); });
      v.addEventListener('timeupdate', function () {
        var d = v.duration; if (!d || !isFinite(d)) return;
        var f = v.currentTime / d;
        if (f >= 0.25) marca('q25'); if (f >= 0.5) marca('q50'); if (f >= 0.75) marca('q75'); if (f >= 0.97) marca('q100');
      });
      v.addEventListener('ended', function () { marca('q100'); });
      if (!v.paused && !v.ended && v.readyState > 2) marca(v.muted ? 'inicio_auto' : 'inicio');   // ya sonaba al empezar a medir
    });
  }

  function iniciarCarruseles() {
    if (!('MutationObserver' in window) || !gestos) return;
    var cuenta = {};
    function registrar(el, tipo) {
      if (el.__csMedCarr) return null; el.__csMedCarr = true;
      var b = bloqueDe(el), pre = (modo === 'cs' && b) ? b.id : 'pag';
      cuenta[pre] = (cuenta[pre] || 0) + 1;
      var r = { el: el, tipo: tipo, bloque: b, id: pre + ':' + cuenta[pre] };
      raicesCarr.push(r); return r;
    }
    function buscar() {
      document.querySelectorAll('[data-cs-carousel]').forEach(function (el) {
        var r = registrar(el, 'galeria'); if (r) observarClase(r, '[data-cs-slide]', 'is-active', null);
      });
      document.querySelectorAll('.swiper, swiper-container').forEach(function (el) {
        if (el.closest('[data-cs-carousel]') || el.querySelectorAll('.swiper-slide').length < 2) return;
        var r = registrar(el, 'swiper'); if (r) observarClase(r, '.swiper-slide', 'swiper-slide-active', '.swiper-slide-duplicate');
      });
      document.querySelectorAll('[data-cs-vids]').forEach(function (el) {
        // cs-videos.liquid pone data-cs-vids en la misma pista (.cs-vids__track): querySelector no se mira a sí mismo.
        var sc = el.matches('.cs-vids__track') ? el : el.querySelector('.cs-vids__track'); if (!sc) return;
        var r = registrar(el, 'videos'); if (r) observarPista(r, sc);
      });
      document.querySelectorAll('[data-cs-strip]').forEach(function (el) {
        var sc = el.querySelector('[data-cs-strip-track]'); if (!sc) return;
        var r = registrar(el, 'tira'); if (r) observarTira(r, sc);
      });
      document.querySelectorAll('[data-cs-compare-scroll]').forEach(function (el) {
        var r = registrar(el, 'tira'); if (r) observarTira(r, el);
      });
      observarVideos();
    }
    buscar(); setTimeout(buscar, 2500); setTimeout(buscar, 7000);   // GemPages y secciones que montan tarde
  }

  // ---------- Ciclo de vida ----------
  function ocultar(motivo) {
    bloques.forEach(function (b) { if (timers[b.id]) { clearTimeout(timers[b.id]); delete timers[b.id]; } });
    enviar('salida', { modo: modo, motivo: motivo, max_orden: maxOrden, secciones_vistas: Object.keys(vistas).length });
  }

  function iniciar() {
    var d = descubrir(); modo = d.modo; bloques = d.bloques;
    var reales = bloques.filter(function (b) { return b.el; });
    var porEl = new Map(reales.map(function (b) { return [b.el, b]; }));
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { var b = porEl.get(en.target); if (b) evaluar(b); });
    }, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
    reales.forEach(function (b) { io.observe(b.el); });
    window.addEventListener('scroll', alDesplazar, { passive: true });
    window.addEventListener('resize', alDesplazar, { passive: true });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(alDesplazar);
      (reales.length ? reales.map(function (b) { return b.el; }) : [raiz]).forEach(function (el) { ro.observe(el); });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') ocultar('oculta'); else evaluarTodas();
    });
    window.addEventListener('pagehide', function (e) { ocultar(e.persisted ? 'cache' : 'cierre'); });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { nuevaCarga(); enviar('vista_pagina', traficoDe({ modo: modo, secciones_total: bloques.length, origen: 'cache' })); evaluarTodas(); }
    });
    nuevaCarga();
    enviar('vista_pagina', traficoDe({ modo: modo, secciones_total: bloques.length, origen: 'carga' }));
    evaluarTodas();
    iniciarCarruseles();
  }
  // Arranca con el DOM listo (este script va con defer). Los tramos se miden con el alto vigente en cada
  // evaluación, así que no hace falta esperar a que carguen las imágenes.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  else iniciar();
})();
